import { Cart } from "@commercetools/platform-sdk"
import * as Sentry from "@sentry/browser"
import { TFunction } from "i18next"
import { CustomerServiceWrapper } from "../../../customer/CustomerService"
import {
  ShippingAddressType,
  InformationPageStateI
} from "../../customerInformation/InformationPageState"
import {
  success,
  CartValidationBase,
  cartSuccess
} from "../../validation/FormValidator"
import { CartValidationResult } from "../../validation/ValidationError"

export class SaveNewCustomerAddressValidation extends CartValidationBase {
  private readonly t: TFunction
  private readonly informationPageState: InformationPageStateI
  private customerService: CustomerServiceWrapper

  constructor(
    t: TFunction,
    informationPageState: InformationPageStateI,
    customerService: CustomerServiceWrapper
  ) {
    super("ValidateSaveNewCustomerAddress")
    this.t = t
    this.informationPageState = informationPageState
    this.customerService = customerService
  }

  save(c: Cart): CartValidationResult {
    const { shippingAddressType, shippingAddress } = this.informationPageState
    if (
      shippingAddressType === ShippingAddressType.NewAddress &&
      shippingAddress
    ) {
      this.customerService
        .fetchCustomer()
        .then(customer => {
          if (customer) {
            this.customerService
              .addShippingAddress(customer, shippingAddress)
              .then(() => success())
          }
        })
        .catch(error => {
          Sentry.captureMessage("Failed to save a address to a customer", {
            extra: {
              error
            },
            level: "warning"
          })
        })
    }
    return cartSuccess(c)
  }
}
